/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { AuthoringRegion } from 'src/core/types/regionTypes';

export class UserMigrationInfoStore {
    public readonly id: string;

    public readonly endpoint: string;

    public readonly serviceKey: string;

    public readonly region: AuthoringRegion;

    @observable public hasMigratedSuccessfully: boolean;

    constructor(id: string, userMigrationData: Partial<UserMigrationInfoStore>) {
        this.id = id;
        this.endpoint = userMigrationData.endpoint;
        this.region = userMigrationData.region;
        this.serviceKey = userMigrationData.serviceKey;
        this.hasMigratedSuccessfully = false;
    }

    /**
     * Sets the migrated value
     */
    @action
    public setHasMigratedSuccessfully(value: boolean) {
        this.hasMigratedSuccessfully = value;
    }
}
